import { SslType } from "../../../../utils/constants";

const SSL_TYPE_LABELS = {
  [SslType.OFF]: "InSecure",
  [SslType.FLEXIBLE]: "Adaptive",
  [SslType.FULL]: "Adaptive E2E",
  [SslType.FULL_STRICT]: "Advanced E2E",
};

function csvCell(value) {
  if (value == null || value === "") return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function certHosts(site) {
  const raw = site?.certs?.host;
  if (Array.isArray(raw)) return raw.filter(Boolean).map(String);
  if (raw) return [String(raw)];
  return [];
}

function formatExpires(site) {
  if (!site?.certs?.validTo) return "";
  const d = new Date(site.certs.validTo);
  if (Number.isNaN(d.getTime())) return String(site.certs.validTo);
  const monthDay = d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const days = site.days_until_expiry;
  return days != null ? `${monthDay} · ${days}d` : monthDay;
}

function sanDisplay(site) {
  const hosts = certHosts(site);
  if (!hosts.length) return site.site_id || "";
  return hosts.join(", ");
}

function siteToRow(site) {
  return [
    site.site_id || "",
    site.certs?.issuer || "",
    sanDisplay(site),
    site.ssl_type_label || SSL_TYPE_LABELS[site.ssl_type] || "",
    formatExpires(site),
    site.rating?.grade || "",
    site.certs?.chain?.length > 0 ? "valid" : "",
    site.auto_renew ? "on" : "off",
  ];
}

// Align with SSL overview dashboard table columns (LE-394).
const CSV_HEADERS = [
  "Domain",
  "Issuer",
  "SAN",
  "Encryption mode",
  "Expires",
  "Grade",
  "Chain",
  "Auto-renew",
];

export function buildSslOverviewCsv(sites) {
  const rows = (sites || []).map(siteToRow);
  return [
    CSV_HEADERS.map(csvCell).join(","),
    ...rows.map((row) => row.map(csvCell).join(",")),
  ].join("\n");
}

export function downloadSslOverviewCsv(sites, filename) {
  const csv = buildSslOverviewCsv(sites);
  const name = filename || `ssl-certificates-${new Date().toISOString().slice(0, 10)}.csv`;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  anchor.click();
  URL.revokeObjectURL(url);
}
